module.exports = __webpack_public_path__ + "static/media/swimmy-facebook-1200x630.835e3bf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swimmy-facebook-1200x630.jpg
// module id = 853
// module chunks = 0